<template>
  <div class="foundation-project-details">
    <div class="navigation-title" style="margin-top: 0rem;margin-left: 0"><span @click="()=>{$router.push('/news')}">{{ $t('News') }} </span><i class="el-icon-arrow-right"></i> {{ object.title }}</div>
    <div>
      <div class="foundation-project-details-img-title">
        <h2>{{ object.title }}</h2>
      </div>
      <!-- <div style="font-size: 1.2rem">
        <span>{{ object.digest }}</span>
      </div> -->
      <div>
        <div v-html='object.content' class="details-content"></div>
        <!-- <iframe :src="object.url" frameborder="0"></iframe> -->
        <!-- <img :src="object.imgUrl" alt="" style="width: 100%;" class="foundation-project-details-img"> -->
      </div>
      <!-- <iframe :src="url"></iframe> -->
    </div>
  </div>
</template>

<script>
import { getSpecFund } from '@/api/index';
export default {
  data() {
    return {
      object: {},
      id: ''
    };
  },
  mounted() {
    const meta = document.createElement('meta');
    meta.setAttribute('name', 'referrer');
    meta.setAttribute('content', 'never');
    document.head.appendChild(meta);

    this.id = this.$route.query.id
	this.fundId = this.$route.query.fundId
    this.getArticleByIds(this.id,this.fundId)
  },
  methods: {
    async getArticleByIds(id,fundId) {
      let form = new FormData();
      form.append("id", id);
	  form.append("moduleTypeId", fundId);
      let res = await getSpecFund(form)
      if (res.data && res.data != null) {
        this.object = res.data
        // this.object.concent = res.data.concent.replace("data-", "")
        console.log("this.object", this.object);

      }

    },
  },
};
</script>

<style lang="less" scoped>
.foundation-project-details {
  background: linear-gradient(to bottom, #f9f9fa, white);
  width: 80%;
  margin: 3rem auto;
  padding: 3rem 10%;
  margin-top: 0;
  padding-top: 0;
  box-sizing: border-box;
  .foundation-project-details-img-title {
    margin: 3rem 0;
    text-align: center;
  }
  .foundation-project-details-img {
    width: 100%;
    margin-top: 3rem;
  }
}

.organization-img {
  width: 100%;
  margin-top: 2rem;
}

.details-content {
  display: inline-block;
  overflow: auto;
  width: 100%;
  img {
    width: 100% !important;
  }
}
</style>
<style>
.details-content p img {
  width: 100% !important;
  /* height: auto !important; */
  object-fit: cover;
  height: 34rem !important;
}
</style>